import axiosInstance from "../axiosInstance";
import API_ROUTES from "../apiRoutes";

export const DashboardAPI = {
  getDashboardData: () => axiosInstance.get(`${API_ROUTES.DASHBOARD.GET}`),
};
